import React from 'react'
import { compose } from 'recompose'
import cn from 'classnames'
import Icons from 'Components/Icons/Icons.component'
import { WithGlobalStylesProps } from 'types/styles/WithGlobalStylesProps'
import HorizontalLineStyles from './HorizontalLine.style'
import { withGlobalStyles } from 'Support/Theme/CreateInjectableStyles/withGlobalStyles'

interface Props {
  any?: any,
}

type FProps = Props & WithGlobalStylesProps<any>

const HorizontalLineComp = (props: FProps) => {
  const {
    classes,
  } = props
  return (
    <div className={classes.wrapper} />
  )
}

export default compose<FProps, Props>(
  withGlobalStyles(HorizontalLineStyles),
)(HorizontalLineComp)
